<script>
import DoughnutChart from '@components/charts/doughnut-chart.vue';

export default {
  components: {
    DoughnutChart,
  },
  props: {
    postWorkoutReview: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      chartData: {
        datasets: [
          {
            backgroundColor: ['#4059E1', '#deded9'],
          },
        ],
      },
      chartOpts: {
        cutoutPercentage: 90,
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="survey-response-block">
    <div class="doughnut-chart-wrapper">
      <div class="doughnut-chart-data">
        <h1 class="chart-num">
          {{ postWorkoutReview.progressTowardsGoal }}
          <small>%</small>
        </h1>
        <DoughnutChart
          class="doughnut-chart"
          :data="{
            ...chartData,
            datasets: [
              {
                ...chartData.datasets[0],
                data: [
                  postWorkoutReview.progressTowardsGoal,
                  100 - postWorkoutReview.progressTowardsGoal,
                ],
              },
            ],
          }"
          :options="chartOpts"
        />
      </div>
      <label>Goal Progress</label>
    </div>
    <div class="doughnut-chart-wrapper">
      <div class="doughnut-chart-data">
        <h1 class="chart-num">
          {{ postWorkoutReview.workoutSatisfaction }}
          <small>%</small>
        </h1>
        <DoughnutChart
          class="doughnut-chart"
          :data="{
            ...chartData,
            datasets: [
              {
                ...chartData.datasets[0],
                data: [
                  postWorkoutReview.workoutSatisfaction,
                  100 - postWorkoutReview.workoutSatisfaction,
                ],
              },
            ],
          }"
          :options="chartOpts"
        />
      </div>
      <label>Workout satisfaction</label>
    </div>
    <div class="doughnut-chart-wrapper">
      <div class="doughnut-chart-data">
        <h1 class="chart-num">
          {{ postWorkoutReview.remainingEnergyPercent }}
          <small>%</small>
        </h1>
        <DoughnutChart
          class="doughnut-chart"
          :data="{
            ...chartData,
            datasets: [
              {
                ...chartData.datasets[0],
                data: [
                  postWorkoutReview.remainingEnergyPercent,
                  100 - postWorkoutReview.remainingEnergyPercent,
                ],
              },
            ],
          }"
          :options="chartOpts"
        />
      </div>
      <label>Energy Left</label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.survey-response-block {
  align-content: center;
  display: flex;
  justify-content: space-around;
  min-height: 20rem;
  padding-bottom: 2rem;
  text-align: center;

  .doughnut-chart-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 14.5%;

    @include media('xxxl', null) {
      width: 11%;
    }

    .doughnut-chart-data {
      align-items: center;
      display: flex;
      justify-content: center;
      position: relative;
      text-align: center;
      width: 100%;

      .doughnut-chart {
        position: absolute;
        width: 100%;
      }

      .chart-num {
        color: $color-heading-text;
        font-weight: normal;
        letter-spacing: -2.76429px;
        line-height: 5rem;
        margin: 0;
        white-space: nowrap;
        @include calc-font-size(2);

        small {
          @include calc-font-size(1.4);

          letter-spacing: -1.96429px;
          margin-left: -2px;
        }
      }
    }

    label {
      @include calc-font-size(0.9);

      font-weight: bold;
      height: 3rem;
      letter-spacing: 0.3px;
      margin-top: 0;
      text-align: center;
      white-space: normal;
    }
  }
}
</style>
